import React from 'react';
import { Button } from '@material-ui/core';
import { CheckOutlined } from '@material-ui/icons';
import { PrimaryCircularProgress } from '../PrimaryCircularProgress';

export const LoaderSubmitButton = ({
  loading,
  disabled,
  children,
  icon = null,
  ...props
}) => {
  return (
    <Button
      startIcon={
        loading ? (
          <PrimaryCircularProgress size={22} />
        ) : (
          icon ?? <CheckOutlined />
        )
      }
      disabled={loading || disabled}
      {...props}
    >
      {children}
    </Button>
  );
};
